import { render, staticRenderFns } from "./SKU.vue?vue&type=template&id=3855f248&"
import script from "./SKU.vue?vue&type=script&lang=js&"
export * from "./SKU.vue?vue&type=script&lang=js&"
import style0 from "./SKU.vue?vue&type=style&index=0&id=3855f248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports